import { render, staticRenderFns } from "./TestCombinaisons.vue?vue&type=template&id=38015763&"
import script from "./TestCombinaisons.vue?vue&type=script&lang=js&"
export * from "./TestCombinaisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports